module.exports = __webpack_public_path__ + "img/IMG_8629_T_L_WoodMatted.3457d764.jpg";